import React from 'react';
import { PieChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToGroupValue, buildChartTitle, buildColorScale } from "../chartHelpers";

const Index = ({chart}) => {
    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData, renderChart) => {
                const data = transformToGroupValue(panelData, chart);
                const colorScale = buildColorScale(data);
                const options = {
                    title: buildChartTitle(chart),
                    resizable: true,
                    height: "400px",
                    pie: { alignment: "center" },
                    color: { scale: colorScale }
                };
                return renderChart(data, <PieChart options={options} data={data} />);
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
